import page from '../../../components/page'
import {store} from "../../../store/store";
import {api,imgPath} from "../../../common/config";
import {ajaxUtil} from "../../../common/AjaxUtil";
import {CommonUtil} from "../../../common/CommonUtil";
import {StorageUtil} from "../../../common/Auth";

export default {
    name: 'othermsg',
    components: {
        page
    },
    data() {
        return {
            imgPath:imgPath,
            msgList: [],
            replyMsg: '',
            idCard: store.func.getUserIdCard(),
            totalPage: 1,
            imgError: store.imgError,
            replayId: -1,
            pageNo: 1,
            replayContent: '',
            pageCount: 7,
            isMsg: false
        }
    },
    computed: {
        fontCount: function () {
            return (200 - this.replyMsg.length)
        }
    },
    watch: {
        $route() {
            this.getList();
        }
    },
    beforeMount() {
        store.message._this.navName="其他消息";
        this.getList();
    },
    methods: {
        getList() {
            this.pageNo = this.$route.query.page || 1;
            var data = {
                readerId: store.user.readerId,
                pageCount: this.pageCount,
                pageNo: this.pageNo,
            }
            ajaxUtil.ajaxJson(api.personalnews.myMessage, data, "POST", (data) => {
                if (data.resultList != null) {
                    this.msgList = data.resultList;
                }
                this.totalPage = data.totalPage;
            }, null, this);
            ajaxUtil.ajaxJson(api.personalnews.readMsg, {readerId: store.user.readerId}, "POST", (data) => {
                store.wrap.unreadCount = 0;
            }, null, this)
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
        },
        /*
          回复消息
        * @index 数组下标
        * */
        onReply(id) {
            this.replayId = id;
        },
        replayComment(id) {
            if (!this.replyMsg.length) {
                this.isMsg = true;
                return false
            }
            var data = {
                replyId: id,
                content: this.replyMsg,
                readerId: store.func.getUserObj().readerId
            }
            ajaxUtil.ajaxJson(api.personalnews.replayComment, data, "POST", (data) => {
                this.replyMsg = '';
                this.replayId = 0;
                CommonUtil.setInfo('回复成功!')
            }, null, this)
        },
        toInfo(item) {
            var index = 0
            var url = api.personalnews.commentIndex.replace('{commentId}', item.commentId);
            ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                index = data.index;
            }, (error) => {
            }, this)
            var idS = [];
            idS.push(item.newsId);
            var data = {
                ids: idS,
                totalCount: 1,
                pageNo: 1,
                totalPage: 1,
                pageCount: 1,
            };
            StorageUtil.storeObject("informationInfo", data);
            this.$router.push({path: '/infordetails', query: {newsId: item.newsId, fromSearch: 0, index}});
        },
        affirm() {
            this.isMsg = false
        },
    }
}
